import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const IconCompany = ({ fontSize = 24, ...other }) => {
  const theme = useTheme();

  return (
    <Box component="span" display="block" {...other}>
      <svg width={fontSize} height={fontSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 21V3H12V7H22V21H2ZM4 21H10V13H4V21ZM4 11H10V9H4V11ZM4 7H10V5H4V7ZM12 19H20V9H12V19ZM14 13V11H18V13H14ZM14 17V15H18V17H14Z"
          fill={theme.palette.text.secondary}
        />
      </svg>
    </Box>
  );
};

IconCompany.propTypes = {
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconCompany;
